import localStore from '@/wrappers/localstore.js';

const lsAuth = localStore.namespace('auth');

export default lsAuth;


// WEBPACK FOOTER //
// ./src/localstorage/auth.localstorage.js